import { withShowIf } from "../../../../../../../../../../components/with-show-if/with-show-If.component";
import { TextField } from "../../../../../../../../../../features/forms/fields/text-field/text-field.component";
import React from "react";
import { FlyerDetailPageFormPositionGetCopyProps } from "./flyer-detail-page-form-position-get-copy.props";

export const FlyerDetailPageFormPositionGetCopy = withShowIf(
  (props: FlyerDetailPageFormPositionGetCopyProps) => (
    <TextField
      form={props.form}
      label={`"Get" Copy Card`}
      name={`copies[${props.languageIndex}].getCopyCard`}
      userPermissions={props.userPermissions}
    />
  )
);
